import { render, staticRenderFns } from "./FormAddRemoveBtn.vue?vue&type=template&id=5d2fc2da&scoped=true&"
import script from "./FormAddRemoveBtn.vue?vue&type=script&lang=js&"
export * from "./FormAddRemoveBtn.vue?vue&type=script&lang=js&"
import style0 from "./FormAddRemoveBtn.vue?vue&type=style&index=0&id=5d2fc2da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2fc2da",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
